import { postVehicleForm, putVehicleForm, getVehicleDetail, getVehicleModelList} from '../api.js'
import vendors from '../vendors.js'
import partitions from '../partitions.js'
import notifications from '../notifications.js'


function _postVehicleForm(content) {
  let promise = postVehicleForm(content)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data.error}`, error)
    })

  return promise
}

function _putVehicleForm(id, content) {
  let promise = putVehicleForm(id, content)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data.error}`, error)
    })

  return promise
}

function _getVendor(vendorId) {
  return vendors.getVendorFromServer()
    .then(() => {
      return vendors.getVendor(vendorId)
    })
}

function _getVehicleDetail(vehicleId) {
  let promise = getVehicleDetail(vehicleId)

  promise.catch(error => {
    notifications.pushError(`Unable to get vehicle data. ${error.response.statusText}`, error)
  })
  return promise
}

function _getVehicleModelList() {
  let promise = getVehicleModelList()

  promise.catch(error => {
    notifications.pushError(`Unable to get vehicle model list. ${error.response.statusText}`, error)
  })
  return promise
}

function _getVehicleFormVendorOptionsFromCapability(user) {
  if (user === undefined) {
    return Promise.resolve([])
  }

  let capSelectVendor = user.can('select_vehicle_vendor')
  let capViewVehicleForm = user.getCapability('view_vehicle_form')
  let vendorOptions = capViewVehicleForm.getVendorOptions()

  let userConfigVendorId = user.getConfig('vendor_id')

  let promiseVendor = vendors.getVendorFromServer()
  let promisePartition = partitions.getPartitionFromServer()

  let promiseFinalVendorOptions = Promise.all([promiseVendor, promisePartition])
    .then(([...allVendors],) => {
      if (capSelectVendor) {
        return allVendors[0].data.map(vendor => ({
          label: `${vendor.name} -- ${partitions.getPartitionNameSync(vendor.partition.id)}`,
          value: vendor.id,
        }))
      }
      if (vendorOptions.length === 0 && userConfigVendorId) {
        vendorOptions = [{ vendor: userConfigVendorId }]
      }
      return vendorOptions
        .filter(option => vendors.getVendorSync(option.vendor) !== undefined)
        .map(function (option) {
          let vendor = vendors.getVendorSync(option.vendor)
          return {
            label: `${vendor.name} -- ${partitions.getPartitionNameSync(vendor.partition.id)}`,
            value: option.vendor,
          }
        })
    })

  return promiseFinalVendorOptions
}


function _canSubmitNewVehicle(user) {
  if (user === undefined) {
    return false
  }

  return user.can('submit_new_vehicle')
}

function _canUpdateVehicle(user) {
    if (user === undefined) {
        return false
    }

    return user.can('edit_vehicle')
}


function _canViewInternalCstData(user) {
  if (user === undefined) {
    return false
  }

  return user.can('view_internal_cst_data')
}


function _init() {
  // do nothing
}

_init()

export default {
  postVehicleForm: _postVehicleForm,
  putVehicleForm: _putVehicleForm,
  getVendor: _getVendor,
  getVehicleDetail: _getVehicleDetail,
  canSubmitNewVehicle: _canSubmitNewVehicle,
  canUpdateVehicle: _canUpdateVehicle,
  canViewInternalCstData: _canViewInternalCstData,
  getVehicleFormVendorOptionsFromCapability: _getVehicleFormVendorOptionsFromCapability,
  getVehicleModelList: _getVehicleModelList,
}